import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SearchLocationsService {

  constructor(private http: HttpClient) {

  }

  getSearchLocations(zip: any, div: any, distance: any, language: any, ipAddress: any) {
    return this.http.get(`${window.location.origin}/api/locations/search/?zip=${zip}&distance=${distance}&language=${language}&ipaddress=${ipAddress}${(div && div.length > 0) ? '&division=' + div : ''}`);
  }

  public GetLocationSearchLang(lang = 'eng') {
    if (lang === 'es') {
      return this.http.get(window.location.origin + '/assets/language/location-search.es.json');
    }
    else {
      return this.http.get(window.location.origin + '/assets/language/location-search.eng.json');
    }
  }

}
